import React, { FC, ButtonHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Button.module.scss'
import { Spinner } from 'components/Spinner'
import cx from 'classnames'

export const VARIANTS = ['primary', 'accent', 'secondary', 'danger', 'outline'] as const
type Variant = typeof VARIANTS[number]

export const SIZES = ['small', 'default'] as const
type Size = typeof SIZES[number]

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  full?: boolean
  variant?: Variant
  loading?: boolean
  size?: Size
}

export const Button: FC<ButtonProps> = ({
  children,
  full,
  type = 'button',
  className = '',
  loading = false,
  disabled = false,
  variant = 'primary',
  size = 'default',
  ...other
}) => {
  const { t } = useTranslation()
  const classes = cx({
    [styles.button]: true,
    [styles.full]: full,
    [styles[variant]]: variant,
    [styles[size]]: size,
    [styles.loading]: loading,
    [className]: className,
  })

  return (
    <button className={classes} type={type} disabled={disabled || loading} {...other}>
      {loading ? <Spinner label={t('common.loading')} data-testid="loader" /> : children}
    </button>
  )
}

Button.displayName = 'Button'
